import copy from 'copy-to-clipboard';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useArticleRecommend } from '@widgets/articles/RecommendModal/model.ts';
import { useAppDispatch } from '@shared/hooks/index.ts';
import { MediumHeader } from '@shared/ui/index.ts';
import { RecommendModalLinkWithCopyButton } from '@shared/ui/modals/recommend-modal-ui/index.tsx';
import { useRecommendArticleMutation } from '@src/api/api-hooks/articles/useRecommendArticleMutation.ts';
import { Loader, ModalMiddle } from '@src/library/components/common/index.ts';
import { showPopup } from '@src/library/redux/modal/index.ts';

export const RecommendModal = () => {
  const { articleId, isModalOpen, closeModal, code } = useArticleRecommend();
  const [hash, setHash] = useState('');

  const dispatch = useAppDispatch();

  const { mutateAsync: recommendArticle, isPending } = useRecommendArticleMutation();

  useEffect(() => {
    if (articleId) {
      recommendArticle({ id: articleId, body: {} }).then((resp) => {
        if (resp.data) {
          setHash(resp.data.hashcode);
        }
      });
    }
  }, [articleId, recommendArticle]);

  const link = useMemo(
    () => `${window.location.origin}/articles/${code}/recommended/${hash}`,
    [hash]
  );

  const onCopy = useCallback(() => {
    copy(link);
    dispatch(showPopup({ type: 'success', text: 'Скопировано в буфер обмена' }));
    closeModal();
  }, [link, dispatch, closeModal]);

  return (
    <ModalMiddle
      isOpen={isModalOpen}
      close={closeModal}
      onRequestClose={closeModal}
      showClose={true}
    >
      {isPending ? (
        <Loader />
      ) : (
        <>
          <MediumHeader title="Рекомендация статьи" onClose={closeModal} />
          <RecommendModalLinkWithCopyButton value={link} onCopy={onCopy} />
        </>
      )}
    </ModalMiddle>
  );
};
